import { SekoEnvironment } from "@redotech/redo-model/integration/seko/seko-environment";
import * as z from "zod/v4";

export const updateSekoIntegration = {
  name: "updateSekoIntegration" as const,
  input: z.object({
    apiKey: z.string().optional(),
    username: z.string().optional(),
    password: z.string().optional(),
    environment: z.enum(SekoEnvironment).optional(),
  }),
  output: z.object({}),
};

export type UpdateSekoIntegrationInput = z.infer<
  typeof updateSekoIntegration.input
>;

export const setSekoIntegration = {
  name: "setSekoIntegration" as const,
  input: z.object({
    apiKey: z.string().min(1, "API Key is required"),
    username: z.string().min(1, "Username is required"),
    password: z.string().min(1, "Password is required"),
    environment: z.enum(SekoEnvironment),
  }),
  output: z.object({}),
};

export type SetSekoIntegrationInput = z.infer<typeof setSekoIntegration.input>;

export const getSekoIntegration = {
  name: "getSekoIntegration" as const,
  input: z.object({}),
  output: z.object({
    sekoIntegration: z.optional(
      z.object({
        enabled: z.boolean(),
        environment: z.enum(SekoEnvironment),
        username: z.string(),
        // Note: We don't return the API key or password for security
      }),
    ),
  }),
};

export type GetSekoIntegrationOutput = z.infer<
  typeof getSekoIntegration.output
>;

export const disconnectSekoIntegration = {
  name: "disconnectSekoIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
